<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- Banner Principal con Saludo -->
    <q-card class="q-mb-md shadow-2 rounded-borders overflow-hidden bg-primary text-white">
      <div class="q-pa-md row items-center justify-between">
        <div class="row items-center">
          <q-avatar size="48px" color="white" text-color="primary" class="q-mr-md shadow-2">
            <q-icon name="space_dashboard" size="sm" />
          </q-avatar>
          <div>
            <div class="text-h6 text-weight-bold">Panel Principal - Dashboard</div>
            <div class="text-caption text-blue-2">
              Gestión centralizada de servicios, empresas, licencias multiempresa y consultas API
            </div>
          </div>
        </div>

        <div class="row q-gutter-xs q-mt-sm-none q-mt-xs">
          <q-btn
            color="white"
            text-color="primary"
            icon="account_balance"
            label="Cuentas Bancarias"
            no-caps
            unelevated
            dense
            class="q-px-sm text-weight-bold"
            @click="dialogCuentas = true"
          />
          <q-btn
            color="white"
            text-color="primary"
            icon="key"
            label="Licencias"
            no-caps
            unelevated
            dense
            class="q-px-sm text-weight-bold"
            @click="$router.push('/aveo/Licencia/Lista')"
          />
          <q-btn
            color="white"
            text-color="primary"
            icon="system_update"
            label="Versiones"
            no-caps
            unelevated
            dense
            class="q-px-sm text-weight-bold"
            @click="$router.push('/aveo/Versiones/Lista')"
          />
          <q-btn
            color="white"
            text-color="primary"
            icon="business"
            label="Empresas"
            no-caps
            unelevated
            dense
            class="q-px-sm text-weight-bold"
            @click="$router.push('/aveo/Empresa/Lista')"
          />
          <q-btn
            color="white"
            text-color="primary"
            icon="build"
            label="Servicios"
            no-caps
            unelevated
            dense
            class="q-px-sm text-weight-bold"
            @click="$router.push('/aveo/Servicio/Lista')"
          />
        </div>
      </div>
    </q-card>

    <!-- Tarjetas de Resumen KPI -->
    <div class="row q-col-gutter-md q-mb-md">
      <div class="col-12 col-sm-6 col-md-3">
        <q-card class="shadow-2 rounded-borders">
          <q-card-section class="row items-center justify-between q-py-sm">
            <div>
              <div class="text-caption text-grey-7 text-uppercase text-weight-bold">Empresas</div>
              <div class="text-h5 text-weight-bolder text-primary">
                {{ resumen.totalEmpresas }}
              </div>
            </div>
            <q-avatar color="blue-1" text-color="primary" icon="business" size="42px" />
          </q-card-section>
        </q-card>
      </div>

      <div class="col-12 col-sm-6 col-md-3">
        <q-card class="shadow-2 rounded-borders">
          <q-card-section class="row items-center justify-between q-py-sm">
            <div>
              <div class="text-caption text-grey-7 text-uppercase text-weight-bold">Servicios Activos</div>
              <div class="text-h5 text-weight-bolder text-positive">
                {{ resumen.serviciosActivos }}
              </div>
            </div>
            <q-avatar color="green-1" text-color="positive" icon="check_circle" size="42px" />
          </q-card-section>
        </q-card>
      </div>

      <div class="col-12 col-sm-6 col-md-3">
        <q-card class="shadow-2 rounded-borders">
          <q-card-section class="row items-center justify-between q-py-sm">
            <div>
              <div class="text-caption text-grey-7 text-uppercase text-weight-bold">Alertas Vencimiento</div>
              <div class="text-h5 text-weight-bolder text-negative">
                {{ resumen.alertasVencimientoCount }}
              </div>
            </div>
            <q-avatar color="red-1" text-color="negative" icon="warning" size="42px" />
          </q-card-section>
        </q-card>
      </div>

      <div class="col-12 col-sm-6 col-md-3">
        <q-card class="shadow-2 rounded-borders">
          <q-card-section class="row items-center justify-between q-py-sm">
            <div>
              <div class="text-caption text-grey-7 text-uppercase text-weight-bold">Consultas Totales</div>
              <div class="text-h5 text-weight-bolder text-purple">
                {{ resumen.totalConsultas }}
              </div>
            </div>
            <q-avatar color="purple-1" text-color="purple" icon="analytics" size="42px" />
          </q-card-section>
        </q-card>
      </div>
    </div>

    <!-- Tabs del Dashboard -->
    <q-card class="q-mt-md shadow-2 rounded-borders">
      <q-tabs
        v-model="tab"
        dense
        class="text-grey-8 bg-white text-primary shadow-1"
        active-color="primary"
        indicator-color="primary"
        align="justify"
        narrow-indicator
        outside-arrows
        mobile-arrows
      >
        <q-tab name="resumen" label="Resumen KPI" icon="insights" />
        <q-tab v-if="tipo == 'user'" name="generales" label="Datos Generales" icon="person" />
        <q-tab v-if="tipo == 'user'" name="facturacion" label="Facturación" icon="receipt" />
        <q-tab v-if="tipo == 'user'" name="comprobantes" label="Comprobantes" icon="description" />
        <q-tab v-if="tipo == 'user'" name="suscripcion" label="Suscripción" icon="subscriptions" />
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="tab" animated>
        <!-- Panel de Resumen Alertas y Top Multiempresa -->
        <q-tab-panel name="resumen" class="q-pa-md q-gutter-y-md">
          <!-- Sección: Top 5 Vencimientos Agrupados por Tipo de Servicio -->
          <div class="q-mb-md">
            <div class="text-subtitle1 text-weight-bold text-grey-9 q-mb-sm row items-center justify-between wrap">
              <div class="row items-center q-mb-xs-sm">
                <q-icon name="notifications_active" color="primary" class="q-mr-sm" size="sm" />
                <span>Top 5 Próximos Vencimientos por Tipo de Servicio</span>
              </div>

              <div class="row items-center q-gutter-xs">
                <q-input
                  v-model="filtroVencimiento"
                  dense
                  outlined
                  placeholder="Buscar RUC o Empresa..."
                  class="bg-white"
                  style="min-width: 220px;"
                  clearable
                >
                  <template v-slot:append>
                    <q-icon name="search" size="xs" />
                  </template>
                </q-input>

                <q-btn
                  flat
                  dense
                  color="primary"
                  icon="event"
                  label="Ver Todos los Vencimientos"
                  no-caps
                  class="text-weight-bold"
                  @click="$router.push('/aveo/Empresa/VencimientoLista')"
                />
              </div>
            </div>

            <div v-if="vencimientosAgrupados.length === 0" class="q-pa-lg bg-white rounded-borders shadow-1 text-center text-grey-7">
              <q-icon name="check_circle_outline" color="positive" size="md" class="q-mb-xs" />
              <div class="text-subtitle2">No se encontraron vencimientos pendientes para la búsqueda realizada.</div>
            </div>

            <div v-else class="row q-col-gutter-md">
              <div
                v-for="grupo in vencimientosAgrupados"
                :key="grupo.servicio"
                class="col-12 col-md-6"
              >
                <q-card flat bordered class="rounded-borders shadow-1">
                  <q-card-section class="bg-primary text-white q-py-xs row items-center justify-between wrap">
                    <div class="text-subtitle2 text-weight-bold row items-center q-my-xs">
                      <q-icon name="build" size="xs" class="q-mr-xs" />
                      {{ grupo.servicio }}
                    </div>
                    <div class="row items-center q-gutter-xs q-my-xs">
                      <q-select
                        v-if="grupo.opcionesAlias && grupo.opcionesAlias.length > 1"
                        v-model="filtrosAlias[grupo.servicio]"
                        :options="grupo.opcionesAlias"
                        dense
                        options-dense
                        outlined
                        dark
                        color="white"
                        bg-color="blue-9"
                        class="text-caption"
                        style="min-width: 130px;"
                      >
                        <template v-slot:selected-item="scope">
                          <span class="text-white text-caption text-weight-bold">
                            <q-icon name="filter_list" size="xs" class="q-mr-xs" />
                            {{ scope.opt || 'Todos' }}
                          </span>
                        </template>
                      </q-select>
                      <q-badge color="white" text-color="primary" class="text-weight-bold">
                        Top {{ grupo.items.length }} por vencer
                      </q-badge>
                    </div>
                  </q-card-section>

                  <q-card-section class="q-pa-none">
                    <q-table
                      :data="grupo.items"
                      :columns="columnsAlertas"
                      row-key="ruc"
                      flat
                      bordered
                      dense
                      hide-bottom
                      :pagination="{ rowsPerPage: 5 }"
                    >
                      <template v-slot:body-cell-alias="props">
                        <q-td :props="props" class="text-center">
                          <q-chip
                            dense
                            size="11px"
                            color="blue-1"
                            text-color="primary"
                            class="text-weight-bold"
                          >
                            {{ props.value || 'General' }}
                          </q-chip>
                        </q-td>
                      </template>
                      <template v-slot:body-cell-dias_restantes="props">
                        <q-td :props="props" class="text-center">
                          <q-chip
                            dense
                            size="11px"
                            :color="props.value < 0 ? 'negative' : (props.value <= 15 ? 'warning' : 'positive')"
                            text-color="white"
                            class="text-weight-bold"
                          >
                            {{ props.value === null ? 'Indefinido' : (props.value < 0 ? `Vencido hace ${Math.abs(props.value)}d` : `${props.value} días`) }}
                          </q-chip>
                        </q-td>
                      </template>
                      <template v-slot:body-cell-estado_alerta="props">
                        <q-td :props="props" class="text-center">
                          <q-chip
                            dense
                            text-color="white"
                            :color="props.value === 'VENCIDO' ? 'negative' : 'warning'"
                            class="text-weight-bold"
                            style="font-size: 11px;"
                          >
                            {{ props.value }}
                          </q-chip>
                        </q-td>
                      </template>
                    </q-table>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </div>

          <div class="row q-col-gutter-md q-mt-sm">
            <div class="col-12">
              <q-card flat bordered class="rounded-borders shadow-1">
                <q-card-section class="bg-secondary text-white q-py-sm">
                  <div class="text-subtitle1 text-weight-bold row items-center">
                    <q-icon name="pie_chart" class="q-mr-sm" />
                    Desglose de Consultas API
                  </div>
                </q-card-section>

                <q-card-section class="q-pa-md">
                  <div class="row q-col-gutter-md">
                    <div class="col-12 col-md-4">
                      <div class="row justify-between text-caption text-weight-bold q-mb-xs">
                        <span>Consultas DNI</span>
                        <span>{{ resumen.totalDNI }}</span>
                      </div>
                      <q-linear-progress :value="porcentajeDNI" color="primary" size="10px" rounded />
                    </div>

                    <div class="col-12 col-md-4">
                      <div class="row justify-between text-caption text-weight-bold q-mb-xs">
                        <span>Consultas RUC</span>
                        <span>{{ resumen.totalRUC }}</span>
                      </div>
                      <q-linear-progress :value="porcentajeRUC" color="secondary" size="10px" rounded />
                    </div>

                    <div class="col-12 col-md-4">
                      <div class="row justify-between text-caption text-weight-bold q-mb-xs">
                        <span>Tipo de Cambio</span>
                        <span>{{ resumen.totalCambio }}</span>
                      </div>
                      <q-linear-progress :value="porcentajeCambio" color="accent" size="10px" rounded />
                    </div>
                  </div>
                </q-card-section>
              </q-card>
            </div>
          </div>

          <!-- Sección de Top Licencias Multiempresa -->
          <q-card flat bordered class="rounded-borders q-mt-md shadow-1">
            <q-card-section class="bg-indigo text-white q-py-sm row items-center justify-between">
              <div class="text-subtitle1 text-weight-bold row items-center">
                <q-icon name="apartment" class="q-mr-sm" />
                Top Licencias con Más Empresas (Multiempresa)
              </div>
              <q-btn
                flat
                dense
                color="white"
                icon="open_in_new"
                label="Ver Todas las Licencias"
                no-caps
                class="text-weight-bold"
                @click="$router.push('/aveo/Licencia/Lista')"
              />
            </q-card-section>

            <q-card-section class="q-pa-none">
              <q-table
                :data="resumen.topLicencias"
                :columns="columnsTopLicencias"
                row-key="license_key"
                :grid="$q.screen.xs"
                flat
                bordered
                dense
                no-data-label="No se encontraron licencias con empresas enlazadas"
              >
                <template v-slot:body-cell-cantidad_empresas="props">
                  <q-td :props="props" class="text-center">
                    <q-chip
                      dense
                      color="indigo"
                      text-color="white"
                      class="text-weight-bold cursor-pointer"
                      clickable
                      @click="verEmpresasLicencia(props.row)"
                    >
                      <q-icon name="business" size="xs" class="q-mr-xs" />
                      {{ props.value }} Empresas
                    </q-chip>
                  </q-td>
                </template>

                <template v-slot:body-cell-actions="props">
                  <q-td :props="props" class="text-right">
                    <q-btn
                      flat
                      round
                      dense
                      color="indigo"
                      icon="visibility"
                      size="sm"
                      @click="verEmpresasLicencia(props.row)"
                    >
                      <q-tooltip>Ver detalle de empresas asociadas</q-tooltip>
                    </q-btn>
                  </q-td>
                </template>
              </q-table>
            </q-card-section>
          </q-card>
        </q-tab-panel>

        <q-tab-panel v-if="tipo == 'user'" name="generales">
          <DatosGenerales />
        </q-tab-panel>

        <q-tab-panel v-if="tipo == 'user'" name="facturacion">
          <DatosFacturacion />
        </q-tab-panel>

        <q-tab-panel v-if="tipo == 'user'" name="comprobantes">
          <ComprobantesEmitidos />
        </q-tab-panel>

        <q-tab-panel v-if="tipo == 'user'" name="suscripcion">
          <DatosSuscripcion />
        </q-tab-panel>
      </q-tab-panels>
    </q-card>

    <!-- Modal Elegante de Cuentas Bancarias -->
    <q-dialog v-model="dialogCuentas">
      <q-card style="width: 550px; max-width: 90vw;" class="rounded-borders">
        <q-card-section class="bg-primary text-white row items-center justify-between q-py-sm">
          <div class="text-subtitle1 text-weight-bold row items-center">
            <q-icon name="account_balance" class="q-mr-sm" />
            Cuentas Bancarias y Medios de Pago
          </div>
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section class="q-pa-md q-gutter-y-sm">
          <div class="text-caption text-grey-8 bg-blue-1 q-pa-sm rounded-borders row items-center">
            <q-icon name="info" color="primary" class="q-mr-sm" size="sm" />
            <span>Enviar sustento al WhatsApp <strong>958863622</strong> o correo <strong>jcalderon235@aveoperu.com</strong> indicando usuario y plan.</span>
          </div>

          <q-list bordered separator class="rounded-borders">
            <q-item>
              <q-item-section avatar>
                <q-avatar color="blue-1" text-color="primary" icon="account_balance" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="text-weight-bold">BCP (Soles)</q-item-label>
                <q-item-label caption>Cuenta: 540-9922141-0-90</q-item-label>
                <q-item-label caption>CCI: 00254000992214109037</q-item-label>
              </q-item-section>
              <q-item-section side>
                <q-btn flat round color="primary" icon="content_copy" size="sm" @click="copiarTexto('540-9922141-0-90')">
                  <q-tooltip>Copiar N° Cuenta</q-tooltip>
                </q-btn>
              </q-item-section>
            </q-item>

            <q-item>
              <q-item-section avatar>
                <q-avatar color="green-1" text-color="positive" icon="attach_money" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="text-weight-bold">BCP (Dólares)</q-item-label>
                <q-item-label caption>Cuenta: 540-9919426-1-75</q-item-label>
                <q-item-label caption>CCI: 00254000991942617538</q-item-label>
              </q-item-section>
              <q-item-section side>
                <q-btn flat round color="primary" icon="content_copy" size="sm" @click="copiarTexto('540-9919426-1-75')">
                  <q-tooltip>Copiar N° Cuenta</q-tooltip>
                </q-btn>
              </q-item-section>
            </q-item>

            <q-item>
              <q-item-section avatar>
                <q-avatar color="purple-1" text-color="purple" icon="account_balance_wallet" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="text-weight-bold">Banco de la Nación</q-item-label>
                <q-item-label caption>Cuenta: 00-151-225977</q-item-label>
                <q-item-label caption>CCI: 01815100015122597719</q-item-label>
              </q-item-section>
              <q-item-section side>
                <q-btn flat round color="primary" icon="content_copy" size="sm" @click="copiarTexto('00-151-225977')">
                  <q-tooltip>Copiar N° Cuenta</q-tooltip>
                </q-btn>
              </q-item-section>
            </q-item>

            <q-item>
              <q-item-section avatar>
                <q-avatar color="deep-purple-1" text-color="deep-purple" icon="smartphone" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="text-weight-bold">YAPE / PLIN</q-item-label>
                <q-item-label caption>Número: 958863622</q-item-label>
              </q-item-section>
              <q-item-section side>
                <q-btn flat round color="primary" icon="content_copy" size="sm" @click="copiarTexto('958863622')">
                  <q-tooltip>Copiar Número</q-tooltip>
                </q-btn>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>

        <q-card-actions align="right" class="bg-grey-1 q-pa-sm">
          <q-btn flat label="Cerrar" color="grey-8" v-close-popup no-caps />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Modal Vinculación / Ver Empresas -->
    <licencia-empresas-modal
      :DialogEmpresas="dialogEmpresas"
      :Licencia="licenciaSeleccionada"
      @CerrarModal="dialogEmpresas = false"
      @EmpresasActualizadas="CargarResumen"
    />
  </q-page>
</template>

<script>
import axios from "axios";
import DatosGenerales from "./DatosUsuario.vue";
import DatosFacturacion from "./DatosFacturacion.vue";
import ComprobantesEmitidos from "./ComprobantesEmitidos.vue";
import DatosdePago from "./DatosdePago.vue";
import DatosSuscripcion from "./DatosSuscripcion.vue";
import LicenciaEmpresasModal from "@/pages/Licencias/LicenciaEmpresasModal.vue";

export default {
  name: "DashboardPage",
  components: {
    DatosGenerales,
    DatosFacturacion,
    ComprobantesEmitidos,
    DatosdePago,
    DatosSuscripcion,
    LicenciaEmpresasModal,
  },
  data() {
    return {
      tab: "resumen",
      dialogEmpresas: false,
      dialogCuentas: false,
      licenciaSeleccionada: {},
      filtroVencimiento: "",
      filtrosAlias: {},
      resumen: {
        totalEmpresas: 0,
        totalServicios: 0,
        serviciosActivos: 0,
        alertasVencimientoCount: 0,
        alertasVencimiento: [],
        totalConsultas: 0,
        totalDNI: 0,
        totalRUC: 0,
        totalCambio: 0,
        topLicencias: [],
      },
      columnsAlertas: [
        { name: "ruc", label: "RUC", field: "ruc", align: "left", sortable: true },
        { name: "razonsocial", label: "Empresa", field: "razonsocial", align: "left" },
        { name: "alias", label: "Tipo", field: "alias", align: "center", sortable: true },
        { name: "vencimiento", label: "Vencimiento", field: "vencimiento", align: "center", sortable: true },
        { name: "dias_restantes", label: "Días Restantes", field: "dias_restantes", align: "center", sortable: true },
        { name: "observaciones", label: "Observaciones", field: row => row.observaciones || "-", align: "left" },
        { name: "estado_alerta", label: "Estado", field: "estado_alerta", align: "center" },
      ],
      columnsTopLicencias: [
        { name: "ruc", label: "RUC / DNI", field: "ruc", align: "left", sortable: true },
        { name: "company_name", label: "Cliente / Razón Social", field: "company_name", align: "left", sortable: true },
        { name: "name", label: "Contacto", field: "name", align: "left" },
        { name: "tipo_licencia", label: "Tipo Licencia", field: row => row.tipo_licencia || "CONTABLE", align: "center" },
        { name: "cantidad_empresas", label: "Cantidad de Empresas", field: "cantidad_empresas", align: "center", sortable: true },
        { name: "actions", label: "Acciones", field: "actions", align: "right" },
      ],
    };
  },
  computed: {
    tipo() {
      return this.$store.state.tipo;
    },
    porcentajeDNI() {
      const tot = this.resumen.totalConsultas || 1;
      return Math.min(1, (this.resumen.totalDNI || 0) / tot);
    },
    porcentajeRUC() {
      const tot = this.resumen.totalConsultas || 1;
      return Math.min(1, (this.resumen.totalRUC || 0) / tot);
    },
    porcentajeCambio() {
      const tot = this.resumen.totalConsultas || 1;
      return Math.min(1, (this.resumen.totalCambio || 0) / tot);
    },
    vencimientosAgrupados() {
      let list = this.resumen.alertasVencimiento || [];
      if (this.filtroVencimiento) {
        const query = this.filtroVencimiento.toLowerCase().trim();
        list = list.filter(
          item =>
            (item.razonsocial && item.razonsocial.toLowerCase().includes(query)) ||
            (item.ruc && item.ruc.includes(query)) ||
            (item.descripcion && item.descripcion.toLowerCase().includes(query)) ||
            (item.alias && item.alias.toLowerCase().includes(query))
        );
      }
      const map = {};
      list.forEach((item) => {
        const key = item.descripcion || item.servicio || "General";
        if (!map[key]) {
          map[key] = [];
        }
        map[key].push(item);
      });
      const result = [];
      Object.keys(map).forEach((key) => {
        const itemsDelGrupo = map[key];
        const aliasesUnicos = Array.from(
          new Set(
            itemsDelGrupo
              .map(i => i.alias)
              .filter(a => a && a.trim() !== "")
          )
        );
        const opcionesAlias = ["Todos", ...aliasesUnicos];

        const aliasSeleccionado = this.filtrosAlias[key] || "Todos";

        let itemsFiltrados = itemsDelGrupo;
        if (aliasSeleccionado && aliasSeleccionado !== "Todos") {
          itemsFiltrados = itemsDelGrupo.filter(i => i.alias === aliasSeleccionado);
        }

        const itemsSorted = itemsFiltrados
          .sort((a, b) => new Date(a.vencimiento) - new Date(b.vencimiento))
          .slice(0, 5);

        result.push({
          servicio: key,
          items: itemsSorted,
          opcionesAlias,
        });
      });
      return result;
    },
  },
  mounted() {
    this.CargarResumen();
  },
  methods: {
    CargarResumen() {
      let me = this;
      axios
        .post("ApiWeb/DashboardResumen.php")
        .then((response) => {
          if (response.data && response.data.data) {
            me.resumen = response.data.data;
          }
        })
        .catch((error) => {
          console.error("Error al cargar resumen del dashboard:", error);
        });
    },
    verEmpresasLicencia(row) {
      this.licenciaSeleccionada = { ...row };
      this.dialogEmpresas = true;
    },
    copiarTexto(txt) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(txt);
      }
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: "Copiado al portapapeles: " + txt,
          color: "positive",
          icon: "content_copy",
          position: "top-right",
          timeout: 2000
        });
      }
    },
  },
};
</script>

<style src="./Dashboard.scss" lang="scss" />
